import React from 'react';
import { Tooltip } from '@applyboard/ui-components';
import { HelpFillIcon } from '@applyboard/ui-icons';
var ThirdPartyRow = function ThirdPartyRow(_ref) {
  var submission_through = _ref.submission_through,
    submission_path_note = _ref.submission_path_note;
  if (!submission_through) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, submission_through), submission_path_note && /*#__PURE__*/React.createElement(Tooltip, {
    title: submission_path_note
  }, /*#__PURE__*/React.createElement(HelpFillIcon, null)));
};
export default ThirdPartyRow;